// extracted by mini-css-extract-plugin
export default {"slide_3":"slider_slide_3__s9VhT"};